// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"bff36b7c","453":"de35e0c6"}[chunkId] + ".chunk.js";
};